import React from "react";
import util from "util";
import validator from "validator";
import moment from "moment";
import $ from "jquery";
import qs from "qs";
import numeral from "numeral";
import "numeral/locales";
import { saveAs } from "file-saver";
import equal from "fast-deep-equal";
import { RRule } from "rrule";
import DOMPurify from "dompurify";

import UBLPaymentTypeResources from "./ublPaymentTypeResources";
import Resources from "./resources";
import Icons from "./icons";

const onLocalHost = window.location.hostname === "localhost";

let config = require("../config/config.json");

if (!onLocalHost) {
  config.authEndpoint = window.location.origin.replace("app", "auth"); // https://auth.lockstep.network
  config.apiEndpoint = window.location.origin.replace("app", "api");
  config.emailDomain = window.location.hostname.replace("app.", "");
}

export function isLocalHost() {
  return onLocalHost;
}

export function isStaging() {
  if (isLocalHost()) {
    return false;
  }
  return (config.apiEndpoint.split(".")[1] || "").toLowerCase() === "stg";
}

export function isQA() {
  if (isLocalHost()) {
    return false;
  }
  return config.apiEndpoint.split(".")[1].toLowerCase() === "demo";
}

export function isLeading() {
  if (isLocalHost()) {
    return false;
  }
  return config.apiEndpoint.split(".")[1].toLowerCase() === "leading";
}

export function isTrailing() {
  if (isLocalHost()) {
    return false;
  }
  return config.apiEndpoint.split(".")[1].toLowerCase() === "trailing";
}

export function isProduction() {
  if (isLocalHost()) {
    return false;
  }
  return config.apiEndpoint.split(".")[1].toLowerCase() === "lockstep";
}

export function replaceAt(arr, index, value) {
  return [...arr.slice(0, index), value, ...arr.slice(index + 1)];
}

export function insertAt(arr, index, value) {
  return [...arr.slice(0, index), value, ...arr.slice(index)];
}

export function removeAt(arr, index) {
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
}

export function getConfig() {
  return { ...config };
}

export function isAdmin() {
  return config.isAdminMode;
}

export function toggleAdmin() {
  if (isLocalHost()) {
    config.isAdminMode = !config.isAdminMode;
  }
}

export function updateConfig(item) {
  config = { ...config, ...item };
}

export function isEmpty(item) {
  if (util.isNullOrUndefined(item) || item === "undefined") return true;
  let type = typeof item;
  if (type === "object" && util.isArray(item)) type = "array";
  switch (type) {
    case "array":
      return item.length === 0;
    case "string":
      return item.trim().length === 0;
    case "object":
      for (let prop in item) {
        if (item.hasOwnProperty(prop)) {
          return false;
        }
      }
      return JSON.stringify(item) === JSON.stringify({});
    default:
      return false;
  }
}

export function getTextWidth(text, font) {
  const canvas = document.createElement("canvas");
  let context = canvas.getContext("2d");
  context.font = font;
  const width = context.measureText(text).width;

  return Math.ceil(width);
}

export function isCustomerPortal(path) {
  return path.includes("customer-portal");
}

export function getDisplaySize(sizeInBytes) {
  let size = sizeInBytes + 0;
  let kbSize = sizeInBytes / 1024;
  if (kbSize < 1) {
    return `${size}bytes`;
  }
  let mbSize = kbSize / 1024;
  if (mbSize < 1) {
    return `${kbSize.toFixed(0)}KB`;
  }
  let gbSize = mbSize / 1024;
  if (gbSize < 1) {
    return `${mbSize.toFixed(1)}MB`;
  }
  return `${gbSize.toFixed(2)}GB`;
}

export function getConversationSubject(subject) {
  let displaySubject = isEmpty(subject) ? "" : subject.trim();
  return displaySubject;
}

export function isGuid(guidText, version) {
  if (util.isString(guidText) === false) return false;
  if (isEmpty(guidText)) return false;
  let ver = version || "all";
  return validator.isUUID(guidText, ver);
}

export function compareDates(a, b) {
  let ma = moment(a);
  let mb = moment(b);
  if (ma.isSame(mb)) {
    return 0;
  } else if (ma.isBefore(mb)) {
    return -1;
  } else {
    return 1;
  }
}

export function compareStrings(a, b) {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}

export function removeLeading(char, from) {
  let to = from || "";
  while (to.length > 0 && to[0] === char) {
    to = to.substring(1);
  }
  return to;
}

const validEmailRegExp = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
export function isEmailValid(emailAddress) {
  return validEmailRegExp.test(emailAddress);
}

export function clone(item) {
  return JSON.parse(JSON.stringify(item));
}

export function deepCompare(a, b) {
  let strA = JSON.stringify(a || {});
  let strB = JSON.stringify(b || {});
  return compareStrings(strA, strB);
}

export function findIndex(array, match) {
  if (isEmpty(array)) {
    return -1;
  }
  let found = -1;
  for (let index = 0; index < array.length; index++) {
    let item = array[index];
    if (match(item)) {
      found = index;
      break;
    }
  }
  return found;
}

export function find(array, match) {
  if (isEmpty(array)) {
    return undefined;
  }
  let found = undefined;
  for (let index = 0; index < array.length; index++) {
    let item = array[index];
    if (match(item)) {
      found = item;
      break;
    }
  }
  return found;
}

export function parseDomain(email) {
  let domain = null;
  email.replace(/^(.*)@(.*)$/i, function($0, $1, $2) {
    domain = $2;
  });

  return domain;
}

export function enableBSTooltips() {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="tooltip"]').on("show.bs.dropdown", function() {
    $(this).tooltip("hide");
    $(this).tooltip("disable");
  });
  $('[data-toggle="tooltip"]').on("hide.bs.dropdown", function() {
    $(this).tooltip("enable");
  });
}

export function disableBSTooltips() {
  $('[data-toggle="tooltip"]').off();
}

export function getQueryParameters(url) {
  let u = url;
  if (u.startsWith("http")) {
    u = url
      .split("?")
      .splice(1)
      .join("?");
  }
  return qs.parse(u, { ignoreQueryPrefix: true });
}

// It is common but not strictly to standards, to encode a space as a +
// In particular, C# HttpUtility.UrlEncode uses + for space (so in C# we
// should use Uri.EscapeDataString instead).
// This function suppresses the exceptions that decodeURIComponent can throw.
export function decodeURLQueryString(singleParameter) {
  let x = singleParameter;
  try {
    x = singleParameter.replace(/\+/g, '%20');
    x = decodeURIComponent(x);
  } catch (e) {
    window.logToConsole && console.log(e);
  }
  return x;
}

export function formatCurrency(amount, currency = "USD") {
  if (isNaN(amount)) {
    return amount;
  }
  let currencyString = `${getCurrencySymbol(currency)} ${numeral(amount).format("0,0.00")}`;
  if(currency === "USD" || currency === "GBP"){
    currencyString = currencyString.replace(" ", "");
  }
  return currencyString;
}

export function coalesceUserName(user = {}) {
  return user.fullName || user.givenName || user.familyName || user.email || "";
}

// 10,000 ticks from C# === one millisecond
export function ticksToReadableTime(ticks, returnNumber) {
  return millisecondsToReadableTime(ticks / 10000, returnNumber);
}

export function millisecondsToReadableTime(milliseconds, returnNumber) {
  if (milliseconds === 0) {
    if (returnNumber) {
      return "0 seconds";
    }
    return "---";
  }

  moment.duration.fn.hackedHumanize = function(thres) {
    let save = {};
    for (let k in thres) {
      save[k] = moment.relativeTimeThreshold(k);
    }
    for (let k in thres) {
      moment.relativeTimeThreshold(k, thres[k]);
    }
    let res = this.humanize();
    for (let k in thres) {
      moment.relativeTimeThreshold(k, save[k]);
    }
    return res;
  };

  let duration = new moment.duration(milliseconds);

  return duration.hackedHumanize({ s: 120, m: 120, h: 120, d: 210, M: 1200 });
}

export function millisecondsToReadableTimeHardCutoff(milliseconds, returnNumber) {
  if (milliseconds === 0) {
    if (returnNumber) {
      return "0 seconds";
    }
    return "---";
  }

  moment.duration.fn.hackedHumanize = function(thres) {
    let save = {};
    for (let k in thres) {
      save[k] = moment.relativeTimeThreshold(k);
    }
    for (let k in thres) {
      moment.relativeTimeThreshold(k, thres[k]);
    }
    let res = this.humanize();
    for (let k in thres) {
      moment.relativeTimeThreshold(k, save[k]);
    }
    return res;
  };

  let duration = new moment.duration(milliseconds);

  return duration.hackedHumanize({ s: 60, m: 60, h: 24, d: 30, M: 12 });
}

export function getInvoiceNum(invoiceId) {
  let invoiceNum;
  if (isEmpty(invoiceId)) {
    return null;
  }
  if (invoiceId.SchemeID === "CCLI") {
    invoiceNum = invoiceId.Value.substring(invoiceId.Value.lastIndexOf(":") + 1) || "";
  } else {
    invoiceNum = invoiceId.Value;
  }

  return invoiceNum;
}

export function createKey() {
  return [...arguments].join(":");
}

export function includes(item, value) {
  if (item !== 0 && !item) {
    return false;
  }
  return item.indexOf(value) >= 0;
}

export function createNewEvent(eventName) {
  let event;
  if (typeof Event === "function") {
    event = new Event(eventName);
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
  }
  return event;
}

export function uniqueId() {
  return Math.random()
    .toString(36)
    .substr(2, 16);
}

export function getFileType(fileName) {
  let fileType = "";
  let lastIndex = fileName.lastIndexOf(".");
  if (lastIndex) {
    fileType = fileName.substr(lastIndex + 1).toLowerCase();
  }

  const imgTypes = ["jpeg", "jpg", "png", "apng", "gif", "svg", "bmp", "bmp ico", "png ico"];
  const txtTypes = ["txt", "rtf"];
  const wordTypes = ["doc", "docx"];

  if (fileType === "pdf") {
    return "pdf";
  } else if (includes(imgTypes, fileType)) {
    return "img";
  } else if (includes(wordTypes, fileType)) {
    return "word";
  } else if (includes(txtTypes, fileType)) {
    return "txt";
  } else {
    return "none";
  }
}

export function getFileNameIconClasses(fileName) {
  switch (getFileType(fileName)) {
    case "pdf":
      return "attachment-pdf " + Icons.filePdf;
    case "txt":
      return "attachment-text " + Icons.fileAlt;
    case "word":
      return "attachment-word " + Icons.fileWord;
    case "img":
      return "attachment-image " + Icons.fileImage;
    default:
      return "attachment-text " + Icons.fileAlt;
  }
}

export function containsHtml(str) {
  return /<[a-z][\s\S]*>/i.test(str);
}

export function htmlToText(htmlString) {
  let doc = new DOMParser().parseFromString(cleanHtml(htmlString), "text/html");
  return doc.body.textContent || "";
}

export function cleanHtml(htmlString) {
  return DOMPurify.sanitize(htmlString);
}

export function getReportsTicks(data) {
  let max = Math.max(null, ...data);
  let maxMoment = moment.duration(max / 10000);
  let maxUnit = "seconds";

  if (maxMoment.asDays() > 1) {
    maxUnit = "days";
  } else if (maxMoment.asHours() > 1) {
    maxUnit = "hours";
  } else if (maxMoment.asMinutes() > 1) {
    maxUnit = "minutes";
  }
  max = Math.ceil(maxMoment.as(maxUnit));
  let ticks = [];
  for (let i = 0; i <= 1; i += 0.25) {
    ticks.push(Math.round(max * i));
  }
  ticks = [...new Set(ticks)];
  ticks = ticks.map(tick => moment.duration(tick, maxUnit).asMilliseconds() * 10000);

  return ticks;
}

export function spliceString(str, index, count, add) {
  // We cannot pass negative indexes directly to the 2nd slicing operation.
  if (index < 0) {
    index = str.length + index;
    if (index < 0) {
      index = 0;
    }
  }

  return str.slice(0, index) + (add || "") + str.slice(index + count);
}

export function formatTaskLabel(date, isCompleted) {
  if (isCompleted) {
    return {
      labelText: Resources.Completed,
      labelClassName: "task-completed"
    };
  }

  const daysDiff = moment()
    .diff(moment.utc(date).local(), "days")
    .toString();

  let labelClassName = "overdue";

  const labelText = moment
    .utc(date)
    .local()
    .calendar(null, {
      sameDay: function(now) {
        labelClassName = "due-today";
        return `[${Resources.DueToday}]`;
      },
      nextDay: function(now) {
        labelClassName = "due-later";
        return `[${Resources.DueTomorrow}]`;
      },
      nextWeek: function(now) {
        labelClassName = "due-later";
        return `[${Resources.Due}] dddd`;
      },
      lastDay: `[${Resources.OverdueByOneDay}]`,
      lastWeek: function(now) {
        return `[${Resources.OverdueBy(daysDiff)}]`;
      },
      sameElse: function(now) {
        if (this.isBefore(now)) {
          return `[${Resources.OverdueBy(daysDiff)}]`;
        }
        labelClassName = "due-later";
        return `[${Resources.Due}] L`;
      }
    });

  return { labelText, labelClassName };
}

export function formatDimensionalDate(toFormat) {
  let date = moment(toFormat);

  if (date.isSame(moment(), "d")) {
    return date.format("LT");
  } else if (date.isSame(moment(), "year")) {
    return date.format("MMM D");
  } else {
    return date.format("l");
  }
}

export function formatDate(dateToFormat, isUTC = false, useTime = true) {
  let date = isUTC ? moment.utc(dateToFormat) : moment(dateToFormat);
  if (useTime) {
    let currentDate = moment();
    if (currentDate.diff(date) < 86400000 && currentDate.date() === date.date()) {
      if (currentDate.diff(date) < 3600000) {
        if (Math.abs(currentDate.diff(date)) <= 60000) {
          return Resources.JustNow;
        } else {
          return moment(date, "ll").fromNow();
        }
      } else {
        return date.format("h:mma");
      }
    } else {
      return date.format("ll");
    }
  } else {
    return date.format("ll");
  }
}

export function getNextBusinessDay(toBusinessDay) {
  // If given date is not a business day then it will return the next business day
  let date = moment(toBusinessDay);
  let dayOfWeek = date.day();
  switch (dayOfWeek) {
    case 6:
      return date.add(2, "day").format();
    case 0:
      return date.add(1, "day").format();
    default:
      return toBusinessDay;
  }
}

export function capStringAtLength(string, length) {
  return string.length > length ? string.substring(0, length - 3) + "..." : string.substring(0, length);
}

export function stringToSentenceCase(string) {
  /*eslint-disable */
  return string.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function(c) {
    return c.toUpperCase();
  });
  /*eslint-enable */
}

export function updateSelectedRows(index, selectedRows, dataLength) {
  let newSelectedRows;
  if (Array.isArray(index)) {
    newSelectedRows = [...selectedRows];
    index.forEach(i => {
      newSelectedRows = updateSelectedRows(i, newSelectedRows, dataLength);
    });
    return newSelectedRows;
  } else if (index === "all") {
    if (selectedRows.length === dataLength) {
      newSelectedRows = [];
    } else {
      let newArray = [];
      for (let i = 0; i < dataLength; i++) {
        newArray.push(i);
      }
      newSelectedRows = newArray;
    }
    newSelectedRows.sort((a, b) => a > b);

    return newSelectedRows;
  } else {
    newSelectedRows = [...selectedRows];
    let indexInSelectedRows = findIndex(selectedRows, row => equal(row, index));
    if (indexInSelectedRows > -1) {
      newSelectedRows.splice(indexInSelectedRows, 1);
    } else {
      newSelectedRows.push(index);
    }

    newSelectedRows.sort((a, b) => a - b);
    return newSelectedRows;
  }
}

export function getReadableFromUBLPaymentType(paymentType) {
  let values = UBLPaymentTypeResources.CodeList.SimpleCodeList.Row;
  let readableUBL = find(values, ublType => ublType.Value[0].SimpleValue === paymentType) || {};
  return (readableUBL.Value || [{}, {}])[1].SimpleValue;
}

export function updateSort(sortBy, currentSortBy, currentSortDirection, updateFunction) {
  if (currentSortBy.toLowerCase() !== sortBy.toLowerCase()) {
    updateFunction(sortBy, "desc");
  }
  else if (currentSortDirection.toLowerCase() === "desc") {
    updateFunction(sortBy, "asc");
  }
  else if (currentSortDirection.toLowerCase() === "asc") {
    updateFunction(sortBy, "desc");
  }
}

export function getAttatchedDocumentLedgerContent() {
  return `<ubl:AttachedDocument xmlns:ubl="urn:oasis:names:specification:ubl:schema:xsd:AttachedDocument-2" xmlns:cac="urn:oasis:names:specification:ubl:schema:xsd:CommonAggregateComponents-2" xmlns:cbc="urn:oasis:names:specification:ubl:schema:xsd:CommonBasicComponents-2"  xmlns:xs="http://www.w3.org/2001/XMLSchema"><cbc:UUID>${generateGUID()}</cbc:UUID></ubl:AttachedDocument>`;
}

export function generateGUID() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}

export function openUrlForDownload(url, fileName) {
  // for non-IE
  if (!window.ActiveXObject) {
    let save = document.createElement("a");
    save.href = url;
    save.target = "_blank";
    let filename = url.substring(url.lastIndexOf("/") + 1);
    save.download = fileName || filename;
    if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
      document.location = save.href;
      // window event not working here
    } else {
      let evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false
      });
      save.dispatchEvent(evt);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }
  }

  // for IE < 11
  else if (!!window.ActiveXObject && document.execCommand) {
    let _window = window.open(url, "_blank");
    _window.document.close();
    _window.document.execCommand("SaveAs", true, fileName || url);
    _window.close();
  }
}

export function saveBlobAsDownload(blob, fileName) {
  saveAs(new Blob([blob]), fileName);
}

export function onBlurCheckFocusable(cb) {
  setTimeout(() => {
    const activeIsChildOfFocusable = Array.from(document.getElementsByClassName("focusable")).some(el =>
      el.contains(document.activeElement)
    );
    const activeisFocusable =
      !isEmpty(document.activeElement.getAttribute("class")) &&
      includes(document.activeElement.getAttribute("class"), "focusable");

    if ((activeIsChildOfFocusable || activeisFocusable) && document.hasFocus()) {
      return;
    }

    cb();
  }, 1);
}

export function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
}

export function sortObjects(objects, sortBy, sortDirection, sortByType = "string") {
  if (sortByType === "date") {
    return [...objects].sort((a, b) => {
      if (a[sortBy] > b[sortBy]) {
        return moment().compareDates(a, b);
      } else {
        return -moment().compareDates(a, b);
      }
    });
  }
  return [...objects].sort((a, b) => {
    if (a[sortBy] > b[sortBy]) {
      if (sortDirection === "desc") {
        return 1;
      }
      return -1;
    } else {
      if (sortDirection === "desc") {
        return -1;
      }
      return 1;
    }
  });
}

export function formatPhoneNumber(str) {
  //Filter only numbers from the input
  let cleaned = ("" + str).replace(/\D/g, "");

  //Check if the input is of correct
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    let intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }

  return null;
}

export function getCurrencySymbol(currencyId) {
  if (isEmpty(currencyId)) {
    return "";
  }

  const currency_symbols = {
    USD: "$", // US Dollar
    CAD: "$", // Canadian Dollar
    EUR: "€", // Euro
    CRC: "₡", // Costa Rican Colón
    GBP: "£", // British Pound Sterling
    ILS: "₪", // Israeli New Sheqel
    INR: "₹", // Indian Rupee
    JPY: "¥", // Japanese Yen
    KRW: "₩", // South Korean Won
    NGN: "₦", // Nigerian Naira
    PHP: "₱", // Philippine Peso
    PLN: "zł", // Polish Zloty
    PYG: "₲", // Paraguayan Guarani
    THB: "฿", // Thai Baht
    UAH: "₴", // Ukrainian Hryvnia
    VND: "₫" // Vietnamese Dong
  };

  return currency_symbols[currencyId] || currencyId;
}

export function copyToClipboard(str) {
  let dummy = document.createElement("input");
  document.body.appendChild(dummy);
  dummy.setAttribute("id", "dummy_id");
  document.getElementById("dummy_id").value = str;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}

export function getATCEnvUrl() {
  if (isProduction()) {
    return "https://my.anytimecollect.com/";
  }
  if (isQA()) {
    return "https://devclient.anytimecollect.com/WebClient_Azure_qa";
  }
  if (isStaging()) {
    return "https://devclient.anytimecollect.com/WebClient_Azure_devqa";
  }
  return "https://devclient.anytimecollect.com/WebClient_Azure_dev";
}

export function getRRule(date) {
  let onDate = moment(date);
  let onDateUTC = onDate.utc();
  let rule = new RRule({
    dtstart: moment.utc().format(),
    freq: RRule.YEARLY,
    count: 1,
    bymonth: onDateUTC.month() + 1,
    bymonthday: onDateUTC.date(),
    byhour: onDateUTC.hours(),
    byminute: onDateUTC.minutes(),
    bysecond: onDateUTC.seconds()
  });
  return rule.toString();
}

export function buildRequestUrl(baseUrl, queryParams = []) {
  let requestString = baseUrl;

  queryParams.forEach((param, i) => {
    if (i === 0) {
      requestString += `?$${param.name}=${param.value}`;
    } else {
      requestString += `&$${param.name}=${param.value}`;
    }
  });

  return requestString;
}

/**
 * @description: This function determines if we need to set a clickback route when the user clicks the 'go back' button. We may not want to under
 *               certain conditions. For example, we don't want to set one if the user is viewing a conversation and tries to go back to the current
 *               activities view.
 */
export function needClickBackRoute(pathName) {
  const lastForwardSlash = pathName.lastIndexOf("/");
  let needClickBack = false;
  let currentView;

  if (lastForwardSlash > -1) {
    currentView = pathName.substr(lastForwardSlash + 1).toLowerCase();

    // These represent the 7 tabs available on the account view under My Network, where there isn't a definitive place to go back to so we need to
    // specify something
    if (currentView === "activities" || currentView === "open-invoices" || currentView === "closed-invoices" || currentView === "payments" ||
      currentView === "profile" || currentView === "contacts" || currentView === "documents") {
      needClickBack = true;
    }
  }

  return needClickBack;
}

export function getNoDocumentsGraphic() {
  return (
    <g fill="none" fillRule="evenodd">
      <path
        fill="#F4F3FF"
        d="M256.633663 24.0594059c6.2009 0 11.227723 5.0268228 11.227723 11.2277228 0 6.2009001-5.026823 11.2277228-11.227723 11.2277228h-64.158415c6.2009 0 11.227722 5.0268227 11.227722 11.2277228 0 6.2009-5.026822 11.2277227-11.227722 11.2277227h35.287128c6.2009 0 11.227723 5.0268227 11.227723 11.2277228s-5.026823 11.2277228-11.227723 11.2277228h-16.318553c-7.818527 0-14.156694 5.0268227-14.156694 11.2277224 0 4.133934 3.207921 7.876508 9.623762 11.227723 6.2009 0 11.227723 5.026823 11.227723 11.227723 0 6.2009-5.026823 11.227723-11.227723 11.227723H73.7821782c-6.2009 0-11.2277228-5.026823-11.2277228-11.227723 0-6.2009 5.0268228-11.227723 11.2277228-11.227723H11.2277228C5.02682271 113.881188 0 108.854365 0 102.653465c0-6.2008997 5.02682271-11.2277224 11.2277228-11.2277224h64.1584158c6.2009001 0 11.2277228-5.0268227 11.2277228-11.2277228S81.5870387 68.970297 75.3861386 68.970297H35.2871287c-6.2009 0-11.2277228-5.0268227-11.2277228-11.2277227 0-6.2009001 5.0268228-11.2277228 11.2277228-11.2277228h64.1584159c-6.2009001 0-11.2277228-5.0268227-11.2277228-11.2277228 0-6.2009 5.0268227-11.2277228 11.2277228-11.2277228H256.633663zm0 44.9108911c6.2009 0 11.227723 5.0268227 11.227723 11.2277228s-5.026823 11.2277228-11.227723 11.2277228c-6.2009 0-11.227722-5.0268227-11.227722-11.2277228s5.026822-11.2277228 11.227722-11.2277228z"
      />
      <path
        fill="#FFF"
        stroke="#BEB6FF"
        strokeLinecap="round"
        strokeWidth="3.5"
        d="M171.09746275 22.45544561l14.91985216 108.81705333 1.34044493 10.91704788c.43182842 3.51696024-2.0691646 6.71808531-5.58612484 7.14991373l-93.92827812 11.53294239c-3.51695965.43182835-6.71808492-2.06916464-7.14991334-5.58612488L66.23251038 37.51142872c-.21591419-1.75847992 1.03458241-3.35904247 2.79306224-3.57495665l.03332354-.00409161 7.79264977-.87395535m6.3012086-.70683126l7.35744625-.82531361"
      />
      <path
        fill="#DEDAFF"
        d="M167.03644893 29.30305224l13.5046427 98.61747678 1.21477826 9.89357497c.39134452 3.18724535-1.84459613 6.08450974-4.99411182 6.47122164l-84.11487626 10.32800815c-3.14951618.38671196-6.01995084-1.88356838-6.41129536-5.07081373L73.01608092 41.87828745c-.13461316-1.0963362.64501741-2.09421783 1.74135362-2.22883099l11.60477308-1.42488697"
      />
      <path
        fill="#FFF"
        stroke="#BEB6FF"
        strokeWidth="3.5"
        d="M176.198643 1.75H99.7113243c-.6213204 0-1.1838204.25183983-1.5909903.65900974-.4071699.40716992-.6590097.96966992-.6590097 1.59099026v126.732673c0 .621321.2518398 1.183821.6590097 1.590991.4071699.407169.9696699.659009 1.5909903.659009h99.4653467c.62132 0 1.18382-.25184 1.59099-.659009.40717-.40717.65901-.96967.65901-1.590991V26.9638138c0-.5969784-.237244-1.1694856-.659502-1.5914824L177.789141 2.40851759C177.367224 1.98686182 176.795139 1.75 176.198643 1.75z"
      />
      <path
        stroke="#BEB6FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.5"
        d="M175.909344 3.85404742V22.4554455c0 2.6575286 2.154353 4.8118812 4.811881 4.8118812h12.72517"
      />
      <path
        stroke="#DEDAFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.5"
        d="M114.958849 27.2673267h41.70297m-41.70297 19.2475248h68.970297m-68.970297 20.8514851h68.970297m-68.970297 20.8514852h68.970297m-68.970297 20.8514852h41.70297"
      />
    </g>
  );
}

export function getErrorGraphic() {
  return (
    <g fill="none" fillRule="evenodd">
      <path fillRule="evenodd" clipRule="evenodd" d="M48.3889 103.981C48.3889 108.778 52.2774 112.667 57.0741 112.667H238.222C243.019 112.667 246.907 108.778 246.907 103.981C246.907 99.1848 243.019 95.2963 238.222 95.2963H230.778C225.981 95.2963 222.093 91.4078 222.093 86.6111C222.093 81.8144 225.981 77.9259 230.778 77.9259H254.352C259.149 77.9259 263.037 74.0374 263.037 69.2407C263.037 64.444 259.149 60.5556 254.352 60.5556H227.056C231.852 60.5556 235.741 56.6671 235.741 51.8704C235.741 47.0737 231.852 43.1852 227.056 43.1852H147.648C152.445 43.1852 156.333 39.2967 156.333 34.5C156.333 29.7033 152.445 25.8148 147.648 25.8148H76.9259C72.1292 25.8148 68.2407 29.7033 68.2407 34.5C68.2407 39.2967 72.1292 43.1852 76.9259 43.1852H27.2963C22.4996 43.1852 18.6111 47.0737 18.6111 51.8704C18.6111 56.6671 22.4996 60.5556 27.2963 60.5556H58.3148C63.1115 60.5556 67 64.444 67 69.2407C67 74.0374 63.1115 77.9259 58.3148 77.9259H8.68519C3.88849 77.9259 0 81.8144 0 86.6111C0 91.4078 3.88849 95.2963 8.68519 95.2963H57.0741C52.2774 95.2963 48.3889 99.1848 48.3889 103.981ZM259.315 112.667C264.112 112.667 268 108.778 268 103.981C268 99.1848 264.112 95.2963 259.315 95.2963C254.518 95.2963 250.63 99.1848 250.63 103.981C250.63 108.778 254.518 112.667 259.315 112.667Z" fill="#F4F3FF"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M93.0556 120.111C77.9802 120.111 65.7593 108.168 65.7593 93.4352C65.7593 78.7025 77.9802 66.7593 93.0556 66.7593C93.6966 66.7593 94.3325 66.7809 94.9625 66.8234C94.5248 64.3867 94.2963 61.8775 94.2963 59.3148C94.2963 36.0166 113.183 17.1296 136.481 17.1296C155.081 17.1296 170.87 29.1673 176.481 45.877C177.811 45.738 179.161 45.6667 180.528 45.6667C201.428 45.6667 218.37 62.3316 218.37 82.8889C218.37 102.419 203.079 118.532 183.63 120.084V120.111H113.537M107.939 120.111H99.2982Z" fill="white"/>
      <path d="M93.0556 121.361C93.7459 121.361 94.3056 120.801 94.3056 120.111C94.3056 119.421 93.7459 118.861 93.0556 118.861V121.361ZM94.9625 66.8234L94.8784 68.0705L96.476 68.1783L96.1928 66.6023L94.9625 66.8234ZM176.481 45.877L175.296 46.2749L175.615 47.2244L176.611 47.1202L176.481 45.877ZM183.63 120.084L183.53 118.838L182.38 118.93V120.084H183.63ZM183.63 120.111V121.361H184.88V120.111H183.63ZM113.537 118.861C112.847 118.861 112.287 119.421 112.287 120.111C112.287 120.801 112.847 121.361 113.537 121.361V118.861ZM107.939 121.361C108.63 121.361 109.189 120.801 109.189 120.111C109.189 119.421 108.63 118.861 107.939 118.861V121.361ZM99.2982 118.861C98.6078 118.861 98.0482 119.421 98.0482 120.111C98.0482 120.801 98.6078 121.361 99.2982 121.361V118.861ZM93.0556 118.861C78.6433 118.861 67.0093 107.451 67.0093 93.4352H64.5093C64.5093 108.885 77.3171 121.361 93.0556 121.361V118.861ZM67.0093 93.4352C67.0093 79.4198 78.6433 68.0093 93.0556 68.0093V65.5093C77.3171 65.5093 64.5093 77.9852 64.5093 93.4352H67.0093ZM93.0556 68.0093C93.6685 68.0093 94.2764 68.0299 94.8784 68.0705L95.0467 65.5762C94.3887 65.5318 93.7247 65.5093 93.0556 65.5093V68.0093ZM96.1928 66.6023C95.7681 64.2383 95.5463 61.803 95.5463 59.3148H93.0463C93.0463 61.9519 93.2815 64.5351 93.7322 67.0444L96.1928 66.6023ZM95.5463 59.3148C95.5463 36.7069 113.874 18.3796 136.481 18.3796V15.8796C112.493 15.8796 93.0463 35.3262 93.0463 59.3148H95.5463ZM136.481 18.3796C154.528 18.3796 169.851 30.0589 175.296 46.2749L177.666 45.4791C171.889 28.2757 155.635 15.8796 136.481 15.8796V18.3796ZM176.611 47.1202C177.898 46.9857 179.204 46.9167 180.528 46.9167V44.4167C179.117 44.4167 177.724 44.4902 176.351 44.6338L176.611 47.1202ZM180.528 46.9167C200.757 46.9167 217.12 63.0414 217.12 82.8889H219.62C219.62 61.6219 202.098 44.4167 180.528 44.4167V46.9167ZM217.12 82.8889C217.12 101.749 202.348 117.336 183.53 118.838L183.729 121.33C203.809 119.728 219.62 103.089 219.62 82.8889H217.12ZM182.38 120.084V120.111H184.88V120.084H182.38ZM183.63 118.861H113.537V121.361H183.63V118.861ZM107.939 118.861H99.2982V121.361H107.939V118.861Z" fill="#BEB6FF"/>
      <circle cx="137.102" cy="95.9167" r="6.82407" stroke="#BEB6FF" strokeWidth="2.5"/>
      <path d="M117.87 81.6482L126.556 74.8326L117.87 68.3444" stroke="#BEB6FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M156.333 81.6482L147.648 74.8326L156.333 68.3444" stroke="#BEB6FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <ellipse rx="8.33795" ry="8.2467" transform="matrix(-1 0 0 1 157.227 37.7837)" stroke="#BEB6FF" strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="174.944" cy="4.72222" r="3.72222" stroke="#BEB6FF" strokeWidth="2"/>
      <circle cx="213.407" cy="24.5741" r="3.72222" fill="#BEB6FF"/>
      <path d="M195.981 17.1854L195.097 18.0693L195.097 18.0693L195.981 17.1854ZM194.213 17.1854L195.097 18.0693L195.097 18.0693L194.213 17.1854ZM189.833 21.5656L188.949 22.4494C189.438 22.9376 190.229 22.9376 190.717 22.4494L189.833 21.5656ZM185.453 17.1854L184.569 18.0693L184.569 18.0693L185.453 17.1854ZM183.685 17.1854L184.569 18.0693L184.569 18.0693L183.685 17.1854ZM183.685 18.9532L184.569 18.0693L184.569 18.0693L183.685 18.9532ZM188.066 23.3333L188.949 24.2172C189.438 23.7291 189.438 22.9376 188.949 22.4494L188.066 23.3333ZM183.843 27.5558L184.727 28.4397L184.727 28.4397L183.843 27.5558ZM183.843 29.3236L184.727 28.4397L183.843 29.3236ZM185.611 29.3236L186.495 30.2075L186.495 30.2075L185.611 29.3236ZM189.833 25.1011L190.717 24.2172C190.229 23.7291 189.438 23.7291 188.949 24.2172L189.833 25.1011ZM191.601 23.3333L190.717 22.4494C190.229 22.9376 190.229 23.7291 190.717 24.2172L191.601 23.3333ZM195.097 18.0693L195.097 18.0693L196.865 19.8371C197.841 18.8608 197.841 17.2778 196.865 16.3015L195.097 18.0693ZM195.097 18.0693L195.097 18.0693L196.865 16.3015C195.889 15.3252 194.306 15.3252 193.33 16.3015L195.097 18.0693ZM190.717 22.4494L195.097 18.0693L193.33 16.3015L188.949 20.6817L190.717 22.4494ZM184.569 18.0693L188.949 22.4494L190.717 20.6817L186.337 16.3015L184.569 18.0693ZM184.569 18.0693L184.569 18.0693L186.337 16.3015C185.361 15.3252 183.778 15.3252 182.802 16.3015L184.569 18.0693ZM184.569 18.0693L184.569 18.0693L182.802 16.3015C181.825 17.2778 181.825 18.8608 182.802 19.8371L184.569 18.0693ZM188.949 22.4494L184.569 18.0693L182.802 19.8371L187.182 24.2172L188.949 22.4494ZM184.727 28.4397L188.949 24.2172L187.182 22.4494L182.959 26.6719L184.727 28.4397ZM184.727 28.4397L184.727 28.4397L182.959 26.6719C181.983 27.6482 181.983 29.2311 182.959 30.2075L184.727 28.4397ZM184.727 28.4397L184.727 28.4397L182.959 30.2075C183.936 31.1838 185.518 31.1838 186.495 30.2075L184.727 28.4397ZM188.949 24.2172L184.727 28.4397L186.495 30.2075L190.717 25.985L188.949 24.2172ZM194.94 28.4397L190.717 24.2172L188.949 25.985L193.172 30.2075L194.94 28.4397ZM194.94 28.4397H194.94L193.172 30.2075C194.148 31.1838 195.731 31.1838 196.707 30.2075L194.94 28.4397ZM194.94 28.4397V28.4397L196.707 30.2075C197.684 29.2311 197.684 27.6482 196.707 26.6719L194.94 28.4397ZM190.717 24.2172L194.94 28.4397L196.707 26.6719L192.485 22.4494L190.717 24.2172ZM195.097 18.0693L190.717 22.4494L192.485 24.2172L196.865 19.8371L195.097 18.0693Z" fill="#BEB6FF"/>
      <path d="M71.2232 42.1572L70.3394 43.041C70.8275 43.5292 71.619 43.5292 72.1071 43.041L71.2232 42.1572ZM69.4555 43.9249L70.3394 44.8088C70.8275 44.3206 70.8275 43.5292 70.3394 43.041L69.4555 43.9249ZM71.2232 45.6927L72.1071 44.8088C71.619 44.3206 70.8275 44.3206 70.3394 44.8088L71.2232 45.6927ZM72.991 43.9249L72.1071 43.041C71.619 43.5292 71.619 44.3206 72.1071 44.8088L72.991 43.9249ZM74.9455 40.2027V40.2027L76.7132 41.9705C77.6895 40.9942 77.6895 39.4112 76.7132 38.4349L74.9455 40.2027ZM74.9455 40.2027H74.9455L76.7132 38.4349C75.7369 37.4586 74.154 37.4586 73.1777 38.4349L74.9455 40.2027ZM72.1071 43.041L74.9455 40.2027L73.1777 38.4349L70.3394 41.2733L72.1071 43.041ZM67.501 40.2027L70.3394 43.041L72.1071 41.2733L69.2688 38.4349L67.501 40.2027ZM67.501 40.2027H67.501L69.2688 38.4349C68.2925 37.4586 66.7096 37.4586 65.7332 38.4349L67.501 40.2027ZM67.501 40.2027V40.2027L65.7332 38.4349C64.7569 39.4112 64.7569 40.9942 65.7332 41.9705L67.501 40.2027ZM70.3394 43.041L67.501 40.2027L65.7332 41.9705L68.5716 44.8088L70.3394 43.041ZM67.501 47.6471L70.3394 44.8088L68.5716 43.041L65.7332 45.8794L67.501 47.6471ZM67.501 47.6471V47.6471L65.7332 45.8794C64.7569 46.8557 64.7569 48.4386 65.7332 49.4149L67.501 47.6471ZM67.501 47.6471H67.501L65.7332 49.4149C66.7096 50.3912 68.2925 50.3912 69.2688 49.4149L67.501 47.6471ZM70.3394 44.8088L67.501 47.6471L69.2688 49.4149L72.1071 46.5766L70.3394 44.8088ZM74.9455 47.6471L72.1071 44.8088L70.3394 46.5766L73.1777 49.4149L74.9455 47.6471ZM74.9455 47.6471H74.9455L73.1777 49.4149C74.154 50.3912 75.7369 50.3912 76.7132 49.4149L74.9455 47.6471ZM74.9455 47.6471V47.6471L76.7132 49.4149C77.6895 48.4386 77.6895 46.8557 76.7132 45.8794L74.9455 47.6471ZM72.1071 44.8088L74.9455 47.6471L76.7132 45.8794L73.8749 43.041L72.1071 44.8088ZM74.9455 40.2027L72.1071 43.041L73.8749 44.8088L76.7132 41.9705L74.9455 40.2027Z" fill="#BEB6FF"/>
      <circle cx="84.3704" cy="28.2963" r="3.72222" fill="#BEB6FF"/>
    </g>
  );
}